export const moneyMask = {
  mask: [
    'D',
    'D#',
    'D##',
    'D ###',
    'D# ###',
    'D## ###',
    'D ### ###',
    'D# ### ###',
    'D## ### ###',
    'D ### ### ###',
  ],
  tokens: {
    D: {
      pattern: /[1-9]/,
    },
  },
}
